module.exports = __webpack_public_path__ + "public/img/yuejie.8b70ed63.png";